module.exports = __webpack_public_path__ + "media/images/ac_templates/201/pblht-e3f3f96d5d69eb80f892959b1901763b.jpg";